import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { MapFeatureFormData, MapTypology } from '../models/map-feature';

@Injectable({
  providedIn: 'root'
})
export class MapFeaturesService {

  constructor(private api: ApiService) {}

  getMapFeatures(filter: any = {}, page: number = 1) {
    return this.api.mapFeatures
      .get()
      .filter(filter)
      .page(page)
      .promise();
  }
  
  getMapFeatureDangerZones(data: any) {
    return this.api.mapFeatures.isDangerZone(data).promise();
  }

  getMapFeature(id: number) {
    return this.api.mapFeaturesById.get(id).promise();
  }

  createMapFeature(feature: MapFeatureFormData) {
    return this.api.mapFeatures.post(feature).promise();
  }

  updateMapFeature(id: number, feature: MapFeatureFormData) {
    const featureWithId = { ...feature, id };
    return this.api.mapFeaturesById.put(featureWithId).promise();
  }

  deleteMapFeature(id: number) {
    return this.api.mapFeatures.delete(id).promise();
  }

  getTypologies() {
    return this.api.catalogEquivalenceMap
      .get()
      .filter({ grouper_: 'map_typology' })
      .all()
      .promise();
  }

  createTypology(typology: Partial<MapTypology>) {
    const typologyData = {
      ...typology,
      grouper_: 'map_typology'
    };
    return this.api.catalogEquivalenceMap.create(typologyData).promise();
  }

  updateTypology(id: number, typology: Partial<MapTypology>) {
    const typologyData = {
      ...typology,
      id,
      grouper_: 'map_typology'
    };
    return this.api.catalogEquivalenceMap.update(id, typologyData).promise();
  }

  deleteTypology(id: number) {
    return this.api.catalogEquivalenceMap.delete(id).promise();
  }
}